export const i18nErrors = {
    name: 'sections.campaigns.new-campaign.wizard-review.validation-issues.errors.name',
    brand: 'sections.campaigns.new-campaign.wizard-review.validation-issues.errors.brand',
    selectedCreativeCategories:
        'sections.campaigns.new-campaign.wizard-review.validation-issues.errors.ad-categories',
    budget: 'sections.campaigns.new-campaign.wizard-review.validation-issues.errors.budget',
    budgetBelowSpent:
        'sections.campaigns.new-campaign.wizard-review.validation-issues.errors.budget-below-spent',
    budgetInsufficient:
        'sections.campaigns.new-campaign.wizard-review.validation-issues.errors.budget-insufficient',
    cpm: 'sections.campaigns.new-campaign.wizard-review.validation-issues.errors.CPM',
    dailyCapBudget:
        'sections.campaigns.new-campaign.wizard-review.validation-issues.errors.daily-cap-budget',
    dailyCapImpressions:
        'sections.campaigns.new-campaign.wizard-review.validation-issues.errors.daily-cap-impressions',
    timingPeriod:
        'sections.campaigns.new-campaign.wizard-review.validation-issues.errors.timing-campaign-duration',
    timingPeriodPast:
        'sections.campaigns.new-campaign.wizard-basics.timing.old-date-range',
    timingTimezone:
        'sections.campaigns.new-campaign.wizard-review.validation-issues.errors.timing-timezone',
    timingDayParting:
        'sections.campaigns.new-campaign.wizard-review.validation-issues.errors.timing-day-parting',
    buyingRules:
        'sections.campaigns.new-campaign.wizard-review.validation-issues.errors.buying-rules',
    screens:
        'sections.campaigns.new-campaign.wizard-review.validation-issues.errors.screens',
    tracking:
        'sections.campaigns.new-campaign.wizard-review.validation-issues.errors.tracking',
};
